import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'
import { setSearchId } from 'actions/SearchActions'
import uuidV4 from 'lib/string/uuidV4Utils'

export default function useSearchSession(searchKey: string): App.SearchSession {
  const dispatch = useAppDispatch()

  const existingSearchSession = useAppSelector(state => state.search.searches[searchKey])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const newSearchId = useMemo(() => uuidV4(), [searchKey])

  useEffect(() => {
    if (!existingSearchSession) {
      dispatch(setSearchId(searchKey, { newSearchId }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey])

  const newSearchSession = useMemo(() => ({ searchId: newSearchId }), [newSearchId])

  return existingSearchSession ?? newSearchSession
}
